import React from 'react'
import { Typography } from 'antd'
import Image from '../jd-image'
import styles from './index.module.less'

interface SkuInfo {
  mainPushFlag: string
  belongTab: string
  skuImg: string
  skuId: string
  sku: string
  skuName: string
  spuName?: string
  spuId: string
  pic: string
  categoryName: string
  firstCatName?: string
  secondCatName?: string
  thirdCatName?: string
  hasApplyPromoAct?: number
  allSkuNum?: number
  appliedSkuNum?: number
  isApplyBlack?: number
  brandName?: string // 子品牌
  skuShadow?: number //是否为影分身商品，1：是、0：否
  skuStatus?: number //销售状态，1：在售、0：下架
}
export default function ({
  data,
  isApplyList = false,
  hideCategoryInfo = true,
  hideBrandName = true,
  showSkuCount = false,
  showSpuIdCopyIcon = false,
  showAppliedSkuCount = false,
  showBlack = true,
  showSkuShadow = false,
}: {
  data: SkuInfo
  isApplyList?: boolean
  hideCategoryInfo?: boolean
  hideBrandName?: boolean
  showSkuCount?: boolean
  showSpuIdCopyIcon?: boolean
  showAppliedSkuCount?: boolean
  showBlack?: boolean
  showSkuShadow?: boolean // 是否显示影分身
}) {
  const blackMask = () => {
    if ((!!data.isApplyBlack && showBlack) || data?.skuStatus === 0) {
      let text = ''
      if (!!data.isApplyBlack && showBlack) {
        text = '已加黑'
      } else if (data?.skuStatus === 0) {
        text = '已下架'
      }
      return <div className={styles['in-black-list']}>{text}</div>
    }
    return null
  }
  const skuTag = () => {
    if (showSkuShadow && data?.skuShadow === 1) {
      const text = '影分身'
      return <div className={styles['sku-tag']}>{text}</div>
    }
    return null
  }
  return (
    <div className="shop-info sku-item">
      {Boolean(data.mainPushFlag) && ['1', '3', '4'].includes(data.belongTab) ? (
        <span className="mainPushFlag-circle">主推</span>
      ) : null}
      <div className={styles['sku-image']}>
        {skuTag()}
        {blackMask()}
        <Image
          src={data.pic || data.skuImg}
          className={styles['logo-img']}
          width={88}
          onError={(e: any) => {
            e.target.src =
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=='
          }}
        />
      </div>
      {isApplyList && data.hasApplyPromoAct === 1 && <div className={styles['img-tag']}>已报跨店满减</div>}
      <div className={styles['shop-title']}>
        {!!data.skuId || data.sku ? (
          <a
            rel="noopener noreferrer"
            href={`https://item.jd.com/${data.skuId || data.sku}.html`}
            target="_blank"
            className="name"
          >
            <Typography.Paragraph
              ellipsis={{ rows: 2, tooltip: true, expandable: false, symbol: '>' }}
              style={{ marginBottom: 0 }}
            >
              {data.skuName || data.spuName}
            </Typography.Paragraph>
          </a>
        ) : (
          <Typography.Paragraph
            ellipsis={{ rows: 2, tooltip: true, expandable: false, symbol: '>' }}
            style={{ marginBottom: 0 }}
          >
            {data.skuName || data.spuName}
          </Typography.Paragraph>
        )}
        <div className={styles['info_bottom']}>
          {(data.skuId || data.sku) && <span style={{ marginRight: 12 }}>SKUID：{data.skuId || data.sku}</span>}
          {data.spuId && (
            <div className={styles['info_spu']}>
              <span>
                SPUID：
                <Typography.Text className={styles['info_bottom']} copyable={showSpuIdCopyIcon}>
                  {data.spuId}
                </Typography.Text>
              </span>
              {showSkuCount && data.allSkuNum ? <div>(含{data.allSkuNum}个SKU)</div> : ''}
              {showAppliedSkuCount && data.appliedSkuNum ? <div>(含{data.appliedSkuNum}个SKU)</div> : ''}
            </div>
          )}
          {!hideCategoryInfo && (
            <div>
              类目：
              {data.categoryName ||
                `${data.firstCatName ? `${data.firstCatName}-` : ''}${
                  data.secondCatName ? `${data.secondCatName}-` : ''
                }${data.thirdCatName || ''}`}
            </div>
          )}
          {!hideBrandName && data?.brandName && <div>子品牌：{data.brandName}</div>}
        </div>
      </div>
    </div>
  )
}
